<template>
    <div class="detail">
        <el-page-header content="课程详情" @back="$router.go(-1)"/>
        <el-descriptions :title="detail.SourceName" style="margin: 40px 0">
            <el-descriptions-item label="课程分类">{{ detail.ClassName }}</el-descriptions-item>
            <el-descriptions-item label="学习时间" :span="10">{{ detail.StartEndTime }}</el-descriptions-item>
            <el-descriptions-item label="应参与人数">{{ detail.JoinPeopleCount }}人</el-descriptions-item>
            <el-descriptions-item label="已参与人数">
                {{ detail.JoinPeopleFactCount }}人（参与率{{ detail.JoinPeoplePercent }}%）
            </el-descriptions-item>
            <el-descriptions-item label="未参与人数">{{ detail.NotJoinPeopleCount }}人</el-descriptions-item>
        </el-descriptions>
        <el-button type="primary" size="medium"
                   @click.stop="handleExport">导出
        </el-button>
        <el-button type="primary"
                   icon="el-icon-search"
                   style="margin-left: auto; float: right;"
                   size="medium" @click.stop="getCourseJoinPeopleList(true)"/>
        <el-input v-model="pagination.keyWord"
                  placeholder="请输入关键字"
                  clearable
                  size="medium" style="margin-right: 20px; float: right; width: 22%"/>
        <el-table :data="joinPeopleList" size="mini"
                  class="clearfix"
                  style="margin-top: 30px"
                  border stripe highlight-current-row>
            <el-table-column label="学员姓名" prop="RealName"></el-table-column>
            <el-table-column label="账号" prop="UserName"></el-table-column>
            <el-table-column label="部门" prop="OrgName"></el-table-column>
            <el-table-column label="完成时间" prop="CompleteTime"></el-table-column>
            <el-table-column label="学习总时长(单位/秒)" prop="TimeNum"></el-table-column>
            <el-table-column label="学分" prop="Credit"></el-table-column>
        </el-table>
        <pagination :page-no.sync="pagination.pageIndex"
                    :total="pagination.total"
                    @change="getCourseJoinPeopleList"
                    :p-size.sync="pagination.pageSize"/>
    </div>
</template>

<script>
import { getCourseJoinPeopleList, getCourseStatDetail, exportCourseJoinPeopleList } from "@/api/manage"
import { downloadUrl } from "download.js";
import pagination from "@/components/Pagination";
export default {
    name: "detail",
    components: {
        pagination
    },
    data(vm) {
        return {
            joinPeopleList: [],
            detail: {},
            pagination: {
                pageIndex: 1,
                pageSize: 10,
                SourceId: vm.$route.query.SourceId,
                keyWord: undefined,
                total: 10
            },
        }
    },
    created() {
        this.getCourseJoinPeopleList()
        this.getCourseStatDetail()
    },
    methods: {
        getCourseJoinPeopleList(isForce) {
            const sourceId = this.$route.query.SourceId
            if (!sourceId) return
            // 是否强制回到第一页
            if (isForce) this.pagination.pageIndex = 1
            getCourseJoinPeopleList({ ...this.pagination, total: undefined }).then(res => {
                this.joinPeopleList = res.data
                this.pagination.total = res.count
            })
        },
        getCourseStatDetail() {
            const sourceId = this.$route.query.SourceId
            if (!sourceId) return
            getCourseStatDetail(sourceId).then(res => {
                this.detail = res
            })
        },
        // 处理导出
        handleExport() {
            const sourceId = this.$route.query.SourceId
            if (sourceId) {
                exportCourseJoinPeopleList(sourceId).then(res => {
                    downloadUrl(this.detail.SourceName + "参与人员表", res)
                })
            }
        },
    }
}
</script>

<style scoped lang="less">
.detail {
    padding: 30px 40px;
    box-sizing: border-box;
}

.course-detail {
    margin: 10px 0 20px;
    font-size: 14px;
    color: #2F3134;

    .desc {
        margin-top: 20px;
        display: flex;
    }
}
</style>
